export const blockIconsDeviceGraphicEq = (
	<span className='material-symbols-outlined'>graphic_eq</span>
);
